import { useRef, useState, useEffect, useContext } from "react";
import { message, Button, Typography, Flex, Spin, Upload } from "antd";
import {
  UploadOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { IndexContext } from "../../context/IndexContext";
import checkIcon from "../../assets/icons8-check.svg";
import closeIcon from "../../assets/icons8-cancel.svg";
import "../../styles/home/camera.css"; // Keep the same CSS for the frame

const { Title } = Typography;


export default function UploadImageFunc({ 
  content, 
  shape,
  isLoading,
  loadingTip,
  onConfirmImage,
  onRejectImage,
  activeTabKey,
}) {
  const filterRef = useRef(null);
  const { isLightTheme, messageApi } = useContext(IndexContext);

  // stores the base64 string of the selected image
  const [capturedImage, setCapturedImage] = useState(null);

  // For call warning message
  const warningMessage = (msg) => {
    messageApi.open({
      type: "warning",
      content: msg,
    });
  };

  // handle the file selection from folder
  const handleFileSelect = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setCapturedImage(e.target.result);
    };
    reader.readAsDataURL(file);
    return false; // Prevent automatic upload by the component
  }

  // for retake/clear the image
  const closePreview = () => {
    setCapturedImage(null);
    if (onRejectImage) {
      onRejectImage();
    }
  };

  // for confirm the image to process via AI
  const confirmImage = () => {
    if (capturedImage) {
      onConfirmImage(capturedImage);
    } else {
      warningMessage("Please select an image first.");
    }
  };  

  // reset when tab changes
  useEffect(() => {
    setCapturedImage(null);
  }, [activeTabKey]);

  return (
    <Flex
      vertical="vertical"
      gap="small"
      style={{ height: "100%", width: "100%" }}
    >
      {/* Top Header Section (Matches Camera Layout) */}
      <Flex ref={filterRef} justify="center" gap="small" align="center">
        <Title level={5} style={{ margin: 0 }}>
          {capturedImage ? "Preview Selection" : "Image Upload Mode"}
        </Title>
      </Flex>

      <div
        className="camera-component"
        style={{
          height: `calc(100% - 8px - ${filterRef?.current?.clientHeight || 40}px)`,
        }}
      >
        <Spin spinning={isLoading} tip={loadingTip} size="large">
          <div className="camera-container">
            <div className="cam-frame">
              <div
                className="cam-subframe"
                style={{
                  backgroundColor: isLightTheme ? "white" : "#1f1f1f",
                  height: "100%",
                }}
              >
                <div className="cam-window icon-window">
                  {!capturedImage ? (
                    /* UPLOAD SELECTION STATE */
                    <div className="camera-group">
                      <Upload
                        accept="image/*"
                        showUploadList={false}
                        beforeUpload={handleFileSelect}
                      >
                        <Button
                          shape="circle"
                          icon={<PictureOutlined style={{ fontSize: "80px" }} />}
                          style={{ width: "200px", height: "200px" }}
                        />
                      </Upload>
                      <Title level={4} style={{ textAlign: "center", marginTop: "20px" }}>
                        {content || "Click to select a plate image"}
                      </Title>
                    </div>
                  ) : (
                    /* IMAGE PREVIEW STATE */
                    <div className="preview-container">
                      {shape === "circle" && (
                        <div className="video-circle" style={{ zIndex: 2 }} />
                      )}
                      <img
                        src={capturedImage}
                        alt="Selected Plate"
                        className="preview-image"
                        style={{ objectFit: "contain" }}
                      />
                      
                      <div className="preview-buttons" style={{ zIndex: 3 }}>
                        <Button
                          className="close-button"
                          onClick={closePreview}
                          shape="circle"
                          disabled={isLoading}
                        >
                          <img src={closeIcon} alt="Cancel" />
                        </Button>
                        <Button
                          className="confirm-button"
                          onClick={confirmImage}
                          shape="circle"
                          disabled={isLoading}
                        >
                          <img src={checkIcon} alt="Confirm" />
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </Flex>
  );
}
